var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-root header-background",class:{
        overlap: _vm.overlap === 'small',
        overlapLarge: _vm.overlap === 'large',
    }},[_c('div',{staticClass:"header-content"},[_c('h2',{staticClass:"header inherit-color"},[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []

export { render, staticRenderFns }